import * as React from "react";
import {IconButton as IconButtonMUI, IconButtonProps, withStyles} from "@material-ui/core";
import {IconButtonStyle as styles} from './iconButton.style';

// forwards ref to the button element, e.g. to anchor a menu to it
const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const {children, ...rest} = props;

  return (
    <IconButtonMUI
      {...rest}
      ref={ref}
    >
      {children}
    </IconButtonMUI>
  );
});

export default withStyles(styles)(IconButton);



// WEBPACK FOOTER //
// ./src/components/common/iconButton/iconButton.component.tsx